export default __webpack_public_path__ + "static/media/Youtube.44016cd7.svg";